var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuesaxOutlineEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33,8.66A4.33,4.33,0,1,1,8.66,4.33,4.332,4.332,0,0,1,4.33,8.66Zm0-7.16A2.83,2.83,0,1,0,7.16,4.33,2.834,2.834,0,0,0,4.33,1.5Z",
    transform: "translate(115.67 195.67)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.545,18.04c-3.76,0-7.31-2.2-9.75-6.02a6.058,6.058,0,0,1,0-6C3.245,2.2,6.8,0,10.545,0s7.3,2.2,9.74,6.02a6.058,6.058,0,0,1,0,6C17.845,15.84,14.3,18.04,10.545,18.04Zm0-16.54c-3.23,0-6.32,1.94-8.48,5.33a4.544,4.544,0,0,0,0,4.38c2.16,3.39,5.25,5.33,8.48,5.33s6.32-1.94,8.48-5.33a4.544,4.544,0,0,0,0-4.38C16.865,3.44,13.775,1.5,10.545,1.5Z",
    transform: "translate(109.455 190.98)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    transform: "translate(108 188)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineEye);
export default __webpack_public_path__ + "static/media/vuesax-outline-eye.7d1bb33d015d934ea514352f947c82c1.svg";
export { ForwardRef as ReactComponent };